import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ProductFaceDefaultMeasurements} from "./product-face-default-measurements.model";
import {environment} from "../../../environments/environment";

@Injectable({providedIn: 'root'})
export class ProductFaceDefaultMeasurementsService {
    constructor(private http: HttpClient) {
    }

    getAll(): Observable<ProductFaceDefaultMeasurements[]> {
        return this.http.get<ProductFaceDefaultMeasurements[]>(
            `${environment.rootUrl}/product-face-default-measurements/get-all/`
        );
    }
}
